export default "__VITE_ASSET__D2Wdw3Hr__"